import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const CARTFUNNELONBEHALFUSEROPTINITEMBLOCK_LEGACY_FIELD_ORDER = [
  "title"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  cartFunnelOnBehalfUserOptinItemBlockDescriptor: _generatedCartFunnelOnBehalfUserOptinItemBlockDescriptor,
  cartFunnelOnBehalfUserOptinItemBlockBlocDefinition,
  cartFunnelOnBehalfUserOptinItemBlockDashboardLayout,
  cartFunnelOnBehalfUserOptinItemBlockConfig,
  cartFunnelOnBehalfUserOptinItemBlockResolveConfig,
  cartFunnelOnBehalfUserOptinItemBlockProperties,
} = doodBlockConfig(
  {
    name: "Cart funnel / On behalf user optin input",
    componentType: 'CartFunnelOnBehalfUserOptinItemBlockComponent',
    category: 'cart',
    description: "Cart funnel / On behalf user optin input.",
    keywords: [],
    allowedIn: [
      { bloc: "CartFunnelFormBlockComponent", slot: "items" },
    ],
    sharedFields: {}
  },

  () => ({
    title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.cart-funnel-on-behalf-user-optin-item.title.label",
        help: "pages.blocks.cart-funnel-on-behalf-user-optin-item.title.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.cart-funnel-on-behalf-user-optin-item.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.cart-funnel-on-behalf-user-optin-item.fieldset.field.label",
            fields: ["title"],
          },
        ],
      },
    ],
  })
);

export function cartFunnelOnBehalfUserOptinItemBlockDescriptor(): IBlockDescriptor;
export function cartFunnelOnBehalfUserOptinItemBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartFunnelOnBehalfUserOptinItemBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartFunnelOnBehalfUserOptinItemBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCartFunnelOnBehalfUserOptinItemBlockDescriptor, cartFunnelOnBehalfUserOptinItemBlockProperties, fieldOrder);
}

export {
  cartFunnelOnBehalfUserOptinItemBlockBlocDefinition,
  cartFunnelOnBehalfUserOptinItemBlockDashboardLayout,
  cartFunnelOnBehalfUserOptinItemBlockProperties,
  cartFunnelOnBehalfUserOptinItemBlockConfig,
  cartFunnelOnBehalfUserOptinItemBlockResolveConfig,
};

export type CartFunnelOnBehalfUserOptinItemBlockConfig = typeof cartFunnelOnBehalfUserOptinItemBlockConfig;
